import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Popover from '@material-ui/core/Popover';

import { setClassNameInDefns } from '../../common/definitionHelper';
import { getUniqueKey } from '../../common/arrayHelper';

import AfitdTypography from '../../common/elemental/AfitdTypography';

import InterviewBlock from './InterviewBlock';

import _map from 'lodash/map';

const styles = theme => ({
    root: {
        backgroundColor: '#FFFFFF',
    },
    popoverPaper: {
        overflow: 'hidden',
    },
    header: {
        padding: '10px 2px 10px 2px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    closeButtonContainer: {
        position: 'absolute',
        right: 0,
        top: 0,
    },
    body: {
        padding: '2px',
        width: '200px',
        maxHeight: '500px',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
    },
});

const getDefns = params => {
    const { props, setInterviewListPopoverOpen } = params;
    const { open, onClose, anchorEl, dayOfWeek, dayOfMonth, classes } = props;
    const { popoverPaper: popoverPaperCls } = classes;

    const defns = {
        interviewListPopover: {
            open,
            onClose,
            anchorEl,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
            classes: { paper: popoverPaperCls },
        },
        dayOfWeekText: {
            variant: 'caption',
            value: dayOfWeek,
        },
        dayOfMonthText: {
            variant: 'h5',
            value: dayOfMonth,
        },
        closeButtonContainer: {
            onClick: handleClickCloseIconButton.bind(null, setInterviewListPopoverOpen),
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const handleClickCloseIconButton = setInterviewListPopoverOpen => {
    setInterviewListPopoverOpen(false);
};

const InterviewListPopoverWeekly = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { interviewList = [], dt, setInterviewListPopoverOpen } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({ props, setInterviewListPopoverOpen });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return (
        <Popover {...defns.interviewListPopover}>
            <div {...defns.header}>
                <div {...defns.dayOfWeekContainer}>
                    <AfitdTypography {...defns.dayOfWeekText} />
                    <div {...defns.closeButtonContainer}>
                        <IconButton {...defns.closeIconButton}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>
                <div {...defns.dayOfMonthContainer}>
                    <AfitdTypography {...defns.dayOfMonthText} />
                </div>
            </div>
            <div {...defns.body}>
                {_map(interviewList, (interview, idx) => {
                    const defn = {
                        interviewData: interview,
                        dt,
                    };
                    return <InterviewBlock key={`interviewBlock-${getUniqueKey()}`} isPopover={true} {...defn} />;
                })}
            </div>
        </Popover>
    );
    //---------------------------------------------------------------------
};

export default withStyles(styles)(InterviewListPopoverWeekly);
